import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./AuthForms.css"; // Import the CSS file


const ForgotPasswordEmp = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.post("https://payweek.com/api/forgot-password-emp", { email });

            //const { data } = await axios.post("http://localhost:5000/forgot-password-emp", { email });
            setMessage(data.message);
            navigate("/resetemppassword");
        } catch (err) {
            console.error(err);
            setMessage(err.response?.data || "Error processing request.");
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <h2>Forgot Password</h2>
                {message && <p className={`auth-message ${message.includes("Error") ? "auth-error" : "auth-success"}`}>{message}</p>}
                <form onSubmit={handleSubmit} className="auth-form">
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="auth-input"
                    />
                    <button type="submit" className="auth-button">Send OTP</button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordEmp;

